import * as Types from 'actions/types';

export default function (state={},action){
    switch(action.type){
        case Types.SAVE_INSTALL_APP_DETAILS_UNTIL_LOGIN:
            return {...state,appIDToInstall:action.payload.appIDToInstall,requireApiKey:action.payload.apiKey};
        case Types.CLEAR_INSTALL_APP_DETAILS:
            return {...state,appIDToInstall:null,requireApiKey:null};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/previewApps.js